<template>
  <el-row :gutter="10">
    <el-col :span="8">
      <div class="role-buttons">
        <el-button type="primary" @click="add">添加新角色</el-button>
      </div>
      <el-table
        :data="list"
        stripe
        highlight-current-row
        @current-change="handleCurrentChange"
        style="width:100%">
        <el-table-column
          prop="id"
          label="No."
          width="80">
        </el-table-column>
        <el-table-column
          prop="name"
          label="角色名称">
        </el-table-column>
      </el-table>
    </el-col>
    <el-col :span="8">
      <div class="role-buttons" style="text-align:right">
        <el-button @click="save" :disabled="!selectRow">保存设置</el-button>
      </div>
      <div class="tree-title">设置菜单权限</div>
      <el-tree
        v-show="selectRow"
        ref="menuTree"
        :data="menuList"
        show-checkbox
        node-key="id"
        :default-expanded-keys="menuDefaultExpandedKeys"
        :props="{
          children: 'children',
          label: 'name'
        }">
      </el-tree>
      <div v-if="!selectRow" style="background-color:#fff;height:200px;text-align:center;padding-top:80px">请在左侧选择角色</div>
    </el-col>
    <el-col :span="8">
      <div class="role-buttons" style="text-align:right">
        <el-button @click="save" :disabled="!selectRow">保存设置</el-button>
      </div>
      <div class="tree-title">设置操作权限</div>
      <el-tree
        v-show="selectRow"
        ref="buttonTree"
        :data="buttonList"
        show-checkbox
        node-key="id"
        :props="{
          children: 'children',
          label: 'name'
        }">
      </el-tree>
      <div v-if="!selectRow" style="background-color:#fff;height:200px;text-align:center;padding-top:80px">请在左侧选择角色</div>
    </el-col>
  </el-row>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import moment from 'moment'
export default {
  mixins: [ListFunc],
  data () {
    return {
      sqlcode: 'role_list',
      pageSize: 0,
      menuList: [],
      buttonList: [],
      selectRow: false,
      menuSaved: true,
      buttonSaved: true
    }
  },
  computed: {
    menuDefaultExpandedKeys () {
      return this.menuList.map(m => m.id)
    },
    buttonDefaultExpandedKeys () {
      return this.buttonList.map(b => b.id)
    }
  },
  mounted () {
    this.fetchMenu()
    this.fetchButton()
  },
  methods: {
    handleCurrentChange (row) {
      this.selectRow = row
      if (!!row) {
        this.$refs.menuTree.setCheckedKeys(JSON.parse(row.menus))
        this.$refs.buttonTree.setCheckedKeys(JSON.parse(row.buttons))
      }
    },
    fetchMenu () {
      this.$http.get('/dbapi/menu_list').then(response => {
        if (response.data.success) {
          let list = response.data.list
          let menus = []
          for (let i = 0; i < list.length; i++) {
            if (list[i].parent_id === 0) {
              let children = []
              for (let j = i + 1; j < list.length; j++) {
                if (list[j].parent_id === list[i].id) {
                  children.push(list[j])
                }
              }
              if (children.length > 0) {
                menus.push({
                  ...list[i],
                  children
                })
              } else {
                menus.push(list[i])
              }
            } else {
              break
            }
          }
          this.menuList = menus
        }
      })
    },
    fetchButton () {
      this.$http.get('/dbapi/button_list').then(response => {
        if (response.data.success) {
          this.buttonList = response.data.list
        }
      })
    },
    add () {
      this.$prompt(`请输入角色名称`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        this.$http.post(`/dbapi/insert_role`, {
          name: value
        }).then(response => {
          if (response.data.success) {
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    },
    save () {
      let parentIds = this.menuList.map(r => r.id)
      let menus = this.$refs.menuTree.getCheckedKeys()
      menus = menus.filter(r => parentIds.indexOf(r) < 0)
      let buttons = this.$refs.buttonTree.getCheckedKeys()
      this.$http.post('/dbapi/update_role', {
        id: this.selectRow.id,
        menus: '[' + menus + ']',
        buttons: '[' +buttons + ']'
      }).then(response => {
        if (response.data.success) {
          this.refresh()
          this.$message({
            type: 'success',
            message: '保存成功'
          })
        } else {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      })
    }
  }
}
</script>

<style>
.role-buttons {
  margin-bottom: 10px;
}
.tree-title {
  background-color: #fff;
  padding: 4px 10px;
  color: #909399;
  font-weight: bold;
  border-bottom: 1px solid #ebeef5;
}
</style>



// WEBPACK FOOTER //
// src/components/sys/Role.vue